"use client";

import React from "react";
import { QuestCard } from "../QuestCard";
import { Masonry } from "@/app/(components)/Wrappers/Masonry";
import { CompletedQuestDto } from "@/api/quests/types";
import useMe from "@/shared/hooks/useMe";

export interface Props {
  quests: CompletedQuestDto[];
  fetchNextPage: () => void;
  hasNextPage?: boolean;
  disableLink?: boolean;
  completed?: boolean;
}

const QuestsList = ({
  quests,
  hasNextPage,
  fetchNextPage,
  disableLink,
  completed,
}: Props) => {
  const { me } = useMe();

  const QuestsSingleColumnList = () => {
    return (
      <div className="flex flex-col items-center">
        {quests.map((quest) => {
          return (
            <QuestCard
              key={quest.id}
              disableLink={disableLink}
              quest={{ ...quest, isLocked: quest.isLocked || !me }}
              completed={completed}
            />
          );
        })}
      </div>
    );
  };

  return (
    <Masonry
      loading={false}
      hasMore={hasNextPage}
      handleLoadMore={fetchNextPage}
      singleColumnList={<QuestsSingleColumnList />}
      singleColumnClassName="lg:hidden md:block"
      multiColumnClassName="lg:flex md:hidden xl:gap-15"
      showHeader={false}
    >
      {quests.map((quest) => {
        return (
          <QuestCard
            key={quest.id}
            disableLink={disableLink}
            quest={{ ...quest, isLocked: quest.isLocked || !me }}
            completed={completed}
          />
        );
      })}
    </Masonry>
  );
};

export default QuestsList;
